module.exports = __webpack_public_path__ + "static/young-leader-photo-tanita_treppmann-69f4de14ffac1de1f4176874e890319b.jpg";